import { imageBlobResizer } from "@iventis/utilities";
import axios from "axios";
import { assetUrlGetter } from "@iventis/api/src/api";

export const imageCompressUrlGetter = async (id: string, pixelRes: number, skipCompression = false): Promise<string> => {
    const url = await assetUrlGetter(id);

    // Skips compression, used when it is not an image
    if (skipCompression) {
        return url;
    }

    const response = await axios.get(url, {
        responseType: "blob",
    });
    return imageBlobResizer(response.data, pixelRes);
};
